/**
 * 途切れた理由の表示（管理アプリ・task-end-reason-audit）
 *
 * 会話中の turn-end パートのうち、正常完了以外だけを表示する。
 * 正常完了は会話が続いていれば自明なので、何も出さない。
 */
import type { TurnEndPart } from '@kyumo/common';
import {
  getTaskEndStateTone,
  getTurnEndReasonLabel,
  getTurnErrorCodeLabel,
  type TaskEndStateTone,
} from './turn-end-labels';

const TEXT_CLASSES: Record<TaskEndStateTone, string> = {
  success: 'text-green-600 dark:text-green-400',
  caution: 'text-amber-600 dark:text-amber-400',
  alert: 'text-red-600 dark:text-red-400',
};

export function TurnEndCard({ part }: { part: TurnEndPart }) {
  if (part.reason === 'completed') return null;

  const tone = getTaskEndStateTone({ kind: 'ended', record: part });
  const error = part.reason === 'error' ? part.error : undefined;

  return (
    <div className="text-xs" data-testid="turn-end-card" data-reason={part.reason}>
      <span className={`font-medium ${TEXT_CLASSES[tone]}`}>
        {getTurnEndReasonLabel(part.reason)}
        {error?.code && <>：{getTurnErrorCodeLabel(error.code)}</>}
      </span>
      {error?.message && (
        <p
          className="mt-1 whitespace-pre-wrap break-words text-muted-foreground"
          data-testid="turn-end-error"
          title={error.code}
        >
          {error.message}
          {error.truncated && '…'}
        </p>
      )}
    </div>
  );
}
